import type { Ref } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import {
  borderRadius,
  boxShadow,
  color,
  compose,
  height,
  maxWidth,
  position,
  space,
  width,
} from 'styled-system';

import type { BoxProps } from './props';

export const Box = forwardRef((props: BoxProps, ref: Ref<HTMLElement>) => (
  <StyledBox ref={ref} {...props} />
));

Box.displayName = 'Box';

const StyledBox = styled.div`
  ${compose(
    borderRadius,
    boxShadow,
    color,
    space,
    position,
    maxWidth,
    width,
    height,
  )};
  box-sizing: border-box;
`;
